module.exports = "<div embed-only=true class=\"toolbox hide-when-medium\"> <button ng-click=openFilters() class=\"button-beta button-plain mode-context-trigger\" translate=app.filter_by_survey>Filter by survey</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/filter-by-survey.html
// module id = 747
// module chunks = 0